import type { AreaCodeGapRow } from '../../../services/phoneNumberHealthService';

const TZ_ORDER = ['Eastern', 'Central', 'Mountain', 'Pacific', 'Other', 'Unknown'];

/** NANP area codes used for inventory alerts (filters test/junk NPAs like 999). */
export function isValidUsAreaCode(areaCode: string): boolean {
  const n = parseInt(areaCode, 10);
  if (!Number.isFinite(n) || areaCode.length !== 3) return false;
  const first = parseInt(areaCode[0]!, 10);
  if (first < 2) return false;
  return n >= 200 && n <= 989;
}

export function sortTimezones<T extends { timezone: string }>(rows: T[]): T[] {
  return [...rows].sort((a, b) => {
    const ai = TZ_ORDER.indexOf(a.timezone);
    const bi = TZ_ORDER.indexOf(b.timezone);
    return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
  });
}

export function sortGapsForDisplay(rows: AreaCodeGapRow[]): AreaCodeGapRow[] {
  return [...rows]
    .filter((r) => isValidUsAreaCode(r.areaCode))
    .sort((a, b) => {
      if (b.missingNumbers !== a.missingNumbers) return b.missingNumbers - a.missingNumbers;
      return b.totalCallableLeads - a.totalCallableLeads;
    });
}

export function formatPercentRate(rate: number): string {
  if (!Number.isFinite(rate) || rate <= 0) return '0%';
  return `${(rate > 1 ? rate : rate * 100).toFixed(1)}%`;
}

/** Jul 7 plan: green &lt; 80%, amber 80–94%, red ≥ 95% */
export function utilizationBarColor(utilization: number): string {
  if (utilization >= 0.95) return 'bg-red-500';
  if (utilization >= 0.8) return 'bg-amber-500';
  return 'bg-green-500';
}

export function sortGapsByUtilization(rows: AreaCodeGapRow[]): AreaCodeGapRow[] {
  return [...rows]
    .filter((r) => isValidUsAreaCode(r.areaCode))
    .sort((a, b) => b.utilizationPercent - a.utilizationPercent);
}
